// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! * [Scalable Text in CSS with Maximum and Minimum Sizes](https://github.com/kevinmack18/SCALABLE-TEXT-IN-CSS) */.footer{background-color:#537e7f;display:flex;flex-direction:column;min-height:125px;position:relative;background-size:cover}@media only screen and (min-width:720px){.footer{flex-direction:row;justify-content:flex-end}}.footer__2wav-logo{float:right;height:110px;position:absolute;top:.5rem;right:.1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
